module.exports = __webpack_public_path__ + "static/media/4EUR.dbed22f4.png";